import { useState, useEffect } from 'react';

/**
 * Hook to debounce a value over time.
 * Helps prevent rapid sequential fires on inputs.
 */
export const useDebounced = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    
    return () => clearTimeout(handler);
  }, [value, delay]);
  
  return debouncedValue;
};
